<template>
    <button
    tabindex="0"
    class="bbox-button oi" 
    :class="[paddings, colors, {success, tiny, outline, link, disabled, danger, block}]"
    @click.prevent="onClickOrEnter($event)"
    @keydown.enter.prevent="onClickOrEnter($event)"
    >
        <!-- @slot Slot onde conteúdo do botão é inserido -->
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: 'BButton',
    props: {
        /**
         * Se true botão tem classes de sucesso
          */
        success: Boolean,
        /**
         * Se true botão tem classes de danger
          */
        danger: Boolean,
        /**
         * Se true botão tem formato de outline (background claro e borda)
          */
        outline: Boolean,
        /**
         * Se true botão tem padding reduzido
          */
        tiny: Boolean,
        /**
         * Se true botão não tem background, nem borda
          */
        link: Boolean,
        /**
         * Se true botão fica desabilitado
          */
        disabled: Boolean,
        /**
         * Se true botão tem `display: block`
          */
        block: Boolean,
        /**
         * Seta a cor do botão, pode ser qualquer cor disponível no DLS
          */
        color: {
            type: String,
            default: 'blue'
        }
    },
    computed: {
        paddings() {
            var classNames = 'padding-horizontal-big padding-vertical-normal';
            if(this.tiny===true) {
                classNames = 'padding-horizontal-normal padding-vertical-tiny';
            } else if(this.link) {
                classNames = '';
            }
            return classNames;
        },
        colors() {
            var classNames = '';
            var color = this.color;
            if(this.disabled) {
                if(this.link) {
                    classNames = 'ink-lighter-3 active-ink-lighter-2';
                } else if(this.outline) {
                    classNames = 'bg-white-darker-3 border border-ink-lighter-3 ink-lighter-3'
                } else {
                    classNames = 'bg-ink-lighter-2 white-darker-4 border border-transparent';
                }
            } else {
                if(this.success) color = 'green';
                else if(this.danger) color = 'red';
                if(this.link) {
                    classNames = `${color}-base
                    active-${color}-darker-2 
                    focus-${color}-darker-1 
                    hover-${color}-darker-1
                    border-none`;
                } else if(this.outline) {
                    classNames = `bg-${color}-lighter-4 border border-${color}-lighter-2 ${color}-base 
                    bg-active-${color}-lighter-3 border-active-${color}-base  
                    bg-hover-${color}-lighter-3 border-hover-${color}-lighter-1  
                    bg-focus-${color}-lighter-3 border-focus-${color}-lighter-1`;
                } else {
                    classNames = `bg-${color}-base white-base 
                    bg-active-${color}-darker-2 
                    bg-hover-${color}-darker-1 
                    bg-focus-${color}-darker-1
                    border-none`;
                }
            }
            return classNames;
        }
    },
    methods: {
        onClickOrEnter(event) {
            /**
             * Evento emitido quando usuário clica ou aperta enter enquanto está focado no componente
             * @property {event}
             * @type {click, keydown}
              */
            this.$emit('clickOrEnter', event);
        }
    }
}
</script>

<style scoped lang="scss">
    .bbox-button {
        cursor: pointer;
        transition: background 0.25s, box-shadow 0.25s, color 0.25s;
        //box-shadow: 0px 2px 2px 0 rgba(0,0,0, 0.14);
        display: inline-block;
        border-radius: 5px;
        box-sizing: border-box;
        font-family: 'Inter', sans-serif;
        letter-spacing: 0.012em;
        font-weight: 500;
        &.block {
            display: block;
        }
        &.disabled {
            cursor: not-allowed !important;
        }
        &:active {
            box-shadow: none;
        }
        &.link {
            background: transparent;
            box-shadow: none;
            &.disabled {
                background: transparent !important;
                border: none !important;
            }
        }
    }
</style>

<docs>
    Botão padrão do DLS

    As importações dos arquivos abaixo são necessárias para o funcionamento do componente:
    - colors-classes.scss
    - spacing.scss

    ```js
    <BButton>Default</BButton>
    <BButton success>Success</BButton>
    <BButton danger>Danger</BButton>
    <BButton disabled>Disabled</BButton>
    <BButton outline>Outline</BButton>
    <BButton outline tiny>Outline+Tiny</BButton>
    <BButton tiny>Tiny</BButton>
    <BButton tiny color="yellow">Yellow Tiny</BButton>
    <BButton link>Link</BButton>

    ```
</docs>